import { useState } from "react";
import { faqItems } from "@/mocks/archiveEntries";

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <span className="reveal inline-flex items-center gap-2 text-xs font-medium tracking-[0.24em] text-primary-600">
              <span className="h-px w-8 bg-primary-400" />
              常见问题
            </span>
            <h2 className="reveal mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              关于存档、留档与备份，你可能想知道
            </h2>
            <p className="reveal mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              下面整理了回看留档时最常见的几个问题。如果还有疑问，可以先从检索入口试一次，再逐步熟悉留档规则。
            </p>

            <div className="reveal mt-8 flex items-center gap-4 rounded-lg border border-background-300 bg-background-50 p-5">
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-100 text-2xl text-accent-700">
                <i className="ri-question-answer-line" />
              </span>
              <div className="text-sm">
                <div className="font-medium text-foreground-900">共 {faqItems.length} 个常见问题</div>
                <div className="mt-1 text-foreground-500">点击问题即可展开查看回答</div>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqItems.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.q}
                  className={`reveal overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                    isOpen ? "border-primary-300" : "border-background-300"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left cursor-pointer md:px-6"
                  >
                    <span className="flex items-start gap-4">
                      <span className="mt-0.5 font-heading text-sm font-bold text-primary-500">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                        {item.q}
                      </span>
                    </span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-lg transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                  {isOpen && (
                    <div className="border-t border-background-200 px-5 pb-6 pt-4 md:px-6">
                      <p className="pl-0 text-sm leading-relaxed text-foreground-600 md:pl-9">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;